export const TRACK_EVENT_PAGE_NAME = {
  INBOX: 'CAIXA_DE_ENTRADA',
  VIEW_COMMUNICATION: 'VISUALIZAR_COMUNICADO',
  CONVERSATIONS: 'CONVERSAS',
  ENTITY_LIST: 'LISTA_DE_ENTIDADES',
  CHANNEL_LIST: 'LISTA_DE_CANAIS',
};
